// ** Initial State
const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
    selectedUser: null
  }
  
  const usersServicios = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_ALL_DATA_SERVICIOS':
        return { ...state, allData: action.data }
      case 'GET_DATA_SERVICIOS':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'GET_USER_SERVICIOS':
        return { ...state, selectedUser: action.selectedUser }
      case 'ADD_USER_SERVICIOS':
        return { ...state }
      case 'DELETE_USER_SERVICIOS':
        return { ...state }
      default:
        return { ...state }
    }
  }
  export default usersServicios
  